/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CursorPaginatedResponseMyRequestsV1 } from '../models/cursor-paginated-response-my-requests-v-1';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { HomepageSummaryGroupV1 } from '../models/homepage-summary-group-v-1';
import { MyRequestsCountV1 } from '../models/my-requests-count-v-1';


/**
 * API for the requests homepage summary.
 */
@Injectable({
  providedIn: 'root',
})
export class HomepageSummaryV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getMyRequestsV1
   */
  static readonly GetMyRequestsV1Path = '/v1/homepage/my-requests';

  /**
   * Get paginated list of requests requiring action from the current user.
   *
   * Returns the Action Required list with cursor-based pagination. Persona OR groups are resolved server-side. User-provided filters narrow within the persona-scoped result; status, createdBy, and assignedTo filters are ignored if supplied.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyRequestsV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMyRequestsV1$Response(params: {

    /**
     * Cursor pagination, sorting, and optional filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseMyRequestsV1>> {

    const rb = new RequestBuilder(this.rootUrl, HomepageSummaryV1Service.GetMyRequestsV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseMyRequestsV1>;
      })
    );
  }

  /**
   * Get paginated list of requests requiring action from the current user.
   *
   * Returns the Action Required list with cursor-based pagination. Persona OR groups are resolved server-side. User-provided filters narrow within the persona-scoped result; status, createdBy, and assignedTo filters are ignored if supplied.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyRequestsV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMyRequestsV1(params: {

    /**
     * Cursor pagination, sorting, and optional filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseMyRequestsV1> {

    return this.getMyRequestsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseMyRequestsV1>) => r.body as CursorPaginatedResponseMyRequestsV1)
    );
  }

  /**
   * Path part for operation getHomepageSummaryV1
   */
  static readonly GetHomepageSummaryV1Path = '/v1/homepage/summary';

  /**
   * Get homepage tile counts for the current user.
   *
   * Returns an ordered list of groups with counts and filter objects. Persona is resolved server-side — the list varies based on whether the user is configured as a section approver on at least one form.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHomepageSummaryV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHomepageSummaryV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<HomepageSummaryGroupV1>> {

    const rb = new RequestBuilder(this.rootUrl, HomepageSummaryV1Service.GetHomepageSummaryV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HomepageSummaryGroupV1>;
      })
    );
  }

  /**
   * Get homepage tile counts for the current user.
   *
   * Returns an ordered list of groups with counts and filter objects. Persona is resolved server-side — the list varies based on whether the user is configured as a section approver on at least one form.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHomepageSummaryV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHomepageSummaryV1(params?: {
  },
  context?: HttpContext

): Observable<HomepageSummaryGroupV1> {

    return this.getHomepageSummaryV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<HomepageSummaryGroupV1>) => r.body as HomepageSummaryGroupV1)
    );
  }

  /**
   * Path part for operation getMyRequestsCountV1
   */
  static readonly GetMyRequestsCountV1Path = '/v1/homepage/my-requests/count';

  /**
   * Get total count of requests requiring action from the current user.
   *
   * Returns the number of requests in the Action Required tab. Derived from tile counts — no extra query. Persona resolved server-side.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyRequestsCountV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyRequestsCountV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MyRequestsCountV1>> {

    const rb = new RequestBuilder(this.rootUrl, HomepageSummaryV1Service.GetMyRequestsCountV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyRequestsCountV1>;
      })
    );
  }

  /**
   * Get total count of requests requiring action from the current user.
   *
   * Returns the number of requests in the Action Required tab. Derived from tile counts — no extra query. Persona resolved server-side.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyRequestsCountV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyRequestsCountV1(params?: {
  },
  context?: HttpContext

): Observable<MyRequestsCountV1> {

    return this.getMyRequestsCountV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<MyRequestsCountV1>) => r.body as MyRequestsCountV1)
    );
  }

}
